/* infire Feuerleiste - Nav-Unterstrich, der als Glutbogen von Punkt zu Punkt schiesst.
   Physik nach dem Original: Kopf laeuft linear, Schweif haengt hinterher und holt auf.
   Der Strich streckt sich bis zur Haelfte und zieht sich danach wieder zusammen. */
(function () {
  const TAU_PEAK = 0.42;   // Anteil der Laufzeit, in dem der Schweif maximal nachhaengt
  const DUR      = 520;    // ms Laufzeit
  const H        = 3;      // Strichdicke in px

  class Feuerleiste {
    constructor(nav, opts) {
      this.nav  = nav;
      this.opts = Object.assign({ funken: true, nachgluehen: 0, dicke: H, abstand: 6, aufHover: false, einflug: false, sperreKlick: true }, opts || {});
      this.items = [...nav.querySelectorAll('[data-fl-item]')];
      this.canvas = document.createElement('canvas');
      this.canvas.className = 'fl-canvas';
      nav.appendChild(this.canvas);
      this.ctx = this.canvas.getContext('2d');
      this.aktiv = this.items.findIndex(i => i.hasAttribute('data-fl-aktiv'));
      if (this.aktiv < 0) this.aktiv = 0;
      this.flug = null;
      this.partikel = [];
      this.spur = [];
      this.resize();
      addEventListener('resize', () => { this.resize(); this.anwerfen(); });
      this.heim = this.aktiv;
      this.items.forEach((el, i) => {
        if (this.opts.aufHover) {
          el.addEventListener('pointerenter', () => this.zu(i));
          el.addEventListener('pointerdown',  () => this.zu(i));
          this.nav.addEventListener('pointerleave', () => this.zu(this.heim));
        } else {
          el.addEventListener('click', e => {
            if (this.opts.sperreKlick) e.preventDefault();
            this.heim = i; this.zu(i);
          });
        }
      });
      document.fonts && document.fonts.ready.then(() => { this.resize(); this.anwerfen(); });
      this.loop = this.loop.bind(this);
      this.laeuft = false;
      this.anwerfen();
      if (this.opts.einflug) { this.wartet = true; setTimeout(() => { this.wartet = false; this.einfliegen(); }, 260); }
    }

    resize() {
      const r = this.nav.getBoundingClientRect();
      const dpr = Math.min(devicePixelRatio || 1, 2);
      this.w = r.width; this.h = r.height;
      this.canvas.width = Math.round(r.width * dpr);
      this.canvas.height = Math.round(r.height * dpr);
      this.canvas.style.width = r.width + 'px';
      this.canvas.style.height = r.height + 'px';
      this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      this.geo = this.items.map(el => {
        const b = el.getBoundingClientRect();
        return { x0: b.left - r.left, x1: b.right - r.left, y: b.bottom - r.top - this.opts.abstand };
      });
    }

    balken(i) {
      const g = this.geo[i];
      // Unterstrich etwas schmaler als der Text, mittig
      const breite = (g.x1 - g.x0) * 0.72;
      const mitte  = (g.x0 + g.x1) / 2;
      return { a: mitte - breite / 2, b: mitte + breite / 2, y: g.y };
    }

    einfliegen() {
      const nach = this.balken(this.aktiv);
      this.flug = {
        t0: performance.now(), dir: 1, x0: -60, x1: nach.b,
        strecke: nach.b + 60, w0: 6, w1: nach.b - nach.a,
        y0: nach.y, y1: nach.y, ziel: this.aktiv
      };
      this.zielIndex = this.aktiv;
      this.aktiv = -1;
      this.anwerfen();
    }

    // Kein Menuepunkt gehoert zu dieser Seite: der Bogen zieht durch und verglimmt.
    durchfliegen() {
      const g = this.geo[0], letzte = this.geo[this.geo.length - 1];
      const y = g ? g.y : this.h - this.opts.abstand;
      const ende = (letzte ? letzte.x1 : this.w) + 70;
      this.flug = {
        t0: performance.now(), dir: 1, x0: -70, x1: ende,
        strecke: ende + 70, w0: 6, w1: 6,
        y0: y, y1: y, ziel: -1
      };
      this.zielIndex = -1;
      this.aktiv = -1;
      this.anwerfen();
    }

    zu(ziel) {
      if (ziel === this.aktiv || this.flug || ziel < 0) return;
      const von = this.balken(this.aktiv), nach = this.balken(ziel);
      const dir = nach.a >= von.a ? 1 : -1;
      const x0 = dir > 0 ? von.b : von.a;          // Startkante
      const x1 = dir > 0 ? nach.b : nach.a;        // Zielkante
      this.flug = {
        t0: performance.now(), dir, x0, x1,
        strecke: Math.abs(x1 - x0),
        w0: von.b - von.a, w1: nach.b - nach.a,
        y0: von.y, y1: nach.y, ziel
      };
      this.items[this.aktiv].removeAttribute('data-fl-aktiv');
      this.items[ziel].setAttribute('data-fl-aktiv', '');
      this.aktiv = -1;
      this.zielIndex = ziel;
      this.anwerfen();
    }

    loop(t) {
      this.zeichne(t);
      const ruht = !this.flug && !this.wartet && !this.partikel.length && !this.spur.length;
      if (ruht) { this.laeuft = false; return; }   // Bild bleibt stehen, CPU frei
      requestAnimationFrame(this.loop);
    }

    anwerfen() {
      if (this.laeuft) return;
      this.laeuft = true;
      requestAnimationFrame(this.loop);
    }

    // Farbverlauf Glut: weissgelber Kern, Amber, dann tiefes Orangerot
    strichFarbe(x, y, laenge, dir, alpha) {
      const g = this.ctx.createLinearGradient(x, y, x - dir * laenge, y);
      g.addColorStop(0.00, `rgba(255,250,225,${alpha})`);
      g.addColorStop(0.18, `rgba(254,213,23,${alpha})`);
      g.addColorStop(0.45, `rgba(245,158,11,${alpha * 0.95})`);
      g.addColorStop(0.78, `rgba(255,90,31,${alpha * 0.7})`);
      g.addColorStop(1.00, `rgba(232,74,12,0)`);
      return g;
    }

    ruhestrich(ctx, bal, gluehen) {
      const d = this.opts.dicke;
      ctx.save();
      ctx.shadowColor = 'rgba(255,138,28,0.85)';
      ctx.shadowBlur = 12 + gluehen * 22;
      const g = ctx.createLinearGradient(bal.a, 0, bal.b, 0);
      g.addColorStop(0, 'rgba(245,158,11,0.25)');
      g.addColorStop(0.5, `rgba(255,224,140,${0.95})`);
      g.addColorStop(1, 'rgba(245,158,11,0.25)');
      ctx.fillStyle = g;
      ctx.fillRect(bal.a, bal.y, bal.b - bal.a, d);
      ctx.restore();
    }

    zeichne(t) {
      const ctx = this.ctx;
      ctx.clearRect(0, 0, this.w, this.h);
      const d = this.opts.dicke;

      // Nachgluehende Spur (Variante Lava)
      if (this.opts.nachgluehen) {
        this.spur = this.spur.filter(s => (t - s.t) < this.opts.nachgluehen);
        for (const s of this.spur) {
          const a = 1 - (t - s.t) / this.opts.nachgluehen;
          ctx.save();
          ctx.shadowColor = `rgba(232,74,12,${a * 0.6})`;
          ctx.shadowBlur = 18 * a;
          ctx.fillStyle = `rgba(255,90,31,${a * 0.30})`;
          ctx.fillRect(s.a, s.y + d * 0.25, s.b - s.a, d * 0.6);
          ctx.restore();
        }
      }

      if (this.wartet) { this.partikel = []; this.spur = []; return; }

      if (!this.flug) {
        if (this.aktiv < 0 && this.zielIndex >= 0) this.aktiv = this.zielIndex;
        // aktiv < 0 heisst: diese Seite hat keinen eigenen Menuepunkt, also kein Ruhestrich
        if (this.aktiv >= 0 && this.geo[this.aktiv]) this.ruhestrich(ctx, this.balken(this.aktiv), 0);
      } else {
        const f = this.flug;
        const p = Math.min((t - f.t0) / DUR, 1);
        const e = p;                                   // Kopf laeuft linear
        const half = 0.5, P = TAU_PEAK / 2;
        // Dreiecksfunktion: Schweif faellt zurueck und holt wieder auf
        let tau = 0;
        if (p > half - P && p <= half)      tau = (p - (half - P)) / P;
        else if (p > half && p < half + P)  tau = ((half + P) - p) / P;
        const kopf = f.x0 + f.dir * f.strecke * e;
        const basis = f.w0 + (f.w1 - f.w0) * e;
        const laenge = basis + f.strecke * 0.55 * tau;
        const schweif = kopf - f.dir * laenge;
        const y = f.y0 + (f.y1 - f.y0) * e;

        ctx.save();
        ctx.shadowColor = 'rgba(255,110,20,0.95)';
        ctx.shadowBlur = 26;
        ctx.fillStyle = this.strichFarbe(kopf, y, laenge, f.dir, 1);
        ctx.fillRect(Math.min(kopf, schweif), y, laenge, d);
        // heisser Kopf
        ctx.shadowBlur = 34;
        ctx.fillStyle = 'rgba(255,252,240,0.95)';
        ctx.fillRect(kopf - f.dir * 9, y - 0.5, 9, d + 1);
        ctx.restore();

        if (this.opts.nachgluehen) this.spur.push({ a: Math.min(kopf, schweif), b: Math.max(kopf, schweif), y, t });

        if (this.opts.funken && Math.random() < 0.9) {
          for (let k = 0; k < 2; k++) {
            this.partikel.push({
              x: kopf - f.dir * Math.random() * 18, y: y + d / 2,
              vx: -f.dir * (0.2 + Math.random() * 1.0), vy: -(0.25 + Math.random() * 0.9),
              leben: 1, r: 0.7 + Math.random() * 1.3
            });
          }
        }

        if (p >= 1) {
          this.flug = null;
          this.aktiv = f.ziel;
          // Aufschlag: Funkenstoss - nur wenn der Bogen wirklich irgendwo landet
          if (this.opts.funken && f.ziel >= 0) {
            const bal = this.balken(f.ziel);
            for (let k = 0; k < 16; k++) {
              this.partikel.push({
                x: f.x1, y: bal.y + d / 2,
                vx: (Math.random() - 0.5) * 2.6, vy: -(0.4 + Math.random() * 1.8),
                leben: 1, r: 0.8 + Math.random() * 1.6
              });
            }
          }
        }
      }

      // Funken steigen auf und verglimmen
      if (this.partikel.length) {
        ctx.save();
        ctx.globalCompositeOperation = 'lighter';
        this.partikel = this.partikel.filter(q => {
          q.x += q.vx; q.y += q.vy; q.vy -= 0.012; q.leben -= 0.028;
          if (q.leben <= 0) return false;
          const a = q.leben;
          ctx.fillStyle = `rgba(255,${Math.round(150 + 90 * a)},${Math.round(40 * a)},${a})`;
          ctx.beginPath(); ctx.arc(q.x, q.y, q.r * a, 0, 6.283); ctx.fill();
          return true;
        });
        ctx.restore();
      }
    }
  }

  window.Feuerleiste = Feuerleiste;
})();

/* Anbindung ans infire-Hauptmenue. Weg 1: Einflug beim Seitenaufruf.
   Entschieden von MR100 am 13.09.2026 ("Live. Weg 1").

   Das Theme markiert die aktive Seite im Menue nicht - gemessen am 13.09.2026 auf
   /collections/holzpellets: kein aria-current, keine Klasse, kein ::after. Der Glutstrich
   uebernimmt das. Seiten ohne eigenen Menuepunkt (Startseite, Produktseiten) bekommen
   keinen liegenbleibenden Strich, sondern einen Bogen, der durchzieht und verglimmt. */
(function () {
  var OPTS = { funken: true, dicke: 4, nachgluehen: 260, abstand: 6, sperreKlick: false };
  var AB_BREITE = 1024;          // darunter zeigt das Theme den Burger, es gibt keine Leiste
  var VERZUG = 320;              // ms, damit Schrift und Layout stehen
  var gebaut = null;

  function sparsam() {
    return window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function pfadVon(el) {
    var a = el.closest('a') || el.querySelector('a');
    var sum = el.closest('summary');
    var roh = (a && a.getAttribute('href')) || (sum && sum.dataset && sum.dataset.link);
    if (!roh) return null;
    try { return new URL(roh, location.origin).pathname.replace(/\/+$/, '') || '/'; }
    catch (e) { return null; }
  }

  function bauen() {
    if (gebaut || sparsam() || innerWidth < AB_BREITE) return;
    if (typeof window.Feuerleiste !== 'function') return;

    var ul = document.querySelector('.header__menu ul.list-menu');
    if (!ul || !ul.getBoundingClientRect().width) return;     // noch unsichtbar
    var items = Array.prototype.slice.call(ul.querySelectorAll(':scope > li .menu__item'));
    if (items.length < 2) return;

    if (getComputedStyle(ul).position === 'static') ul.style.position = 'relative';
    items.forEach(function (el) { el.setAttribute('data-fl-item', ''); });

    var hier = location.pathname.replace(/\/+$/, '') || '/';
    var treffer = -1;
    items.forEach(function (el, i) { if (treffer < 0 && pfadVon(el) === hier) treffer = i; });
    if (treffer >= 0) items[treffer].setAttribute('data-fl-aktiv', '');

    var fl = new window.Feuerleiste(ul, OPTS);
    fl.wartet = true;                                          // bis zum Einflug nichts zeigen
    // z-index 3: die Menuelinks des Themes liegen auf 2 und verdecken das Canvas sonst
    // vollstaendig - live gemessen am 13.09.2026, bei 0 und auto blieb der Strich unsichtbar.
    // pointer-events:none haelt trotzdem jeden Klick durch.
    Object.assign(fl.canvas.style, {
      position: 'absolute', left: '0', top: '0',
      pointerEvents: 'none', zIndex: '3'
    });
    gebaut = fl;
    window.infireFeuerleiste = fl;

    setTimeout(function () {
      fl.wartet = false;
      fl.resize();
      if (treffer >= 0) fl.einfliegen(); else fl.durchfliegen();
    }, VERZUG);
  }

  addEventListener('resize', function () { if (!gebaut) bauen(); }, { passive: true });
  if (document.readyState === 'loading') addEventListener('DOMContentLoaded', bauen);
  else bauen();
})();
